import React, { createContext, useState, useContext } from 'react';

interface AuthContextType {
  isAuthenticated: boolean;
  login: (email: string, password: string) => Promise<void>;
  signup: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  
  const login = async (email: string, password: string) => {
    // Implement real authentication later
    console.log('Login with', email, password);
    setIsAuthenticated(true);
  };
  
  const signup = async (email: string, password: string) => {
    // Implement real authentication later
    console.log('Signup with', email, password);
    setIsAuthenticated(true);
  };
  
  const logout = async () => {
    // Implement real logout later
    console.log('Logout');
    setIsAuthenticated(false);
  };
  
  return (
    <AuthContext.Provider value={{ 
      isAuthenticated, 
      login,
      signup,
      logout
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}; 